export const LINK_TO_MODAL_PARTIAL = 'LINK_TO_MODAL_PARTIAL';
export const REMOTE_COPY_MODAL_PARTIAL = 'REMOTE_COPY_MODAL_PARTIAL';

export const CREATE_ACO_MODAL = 'CREATE_ACO_MODAL';
